import PropTypes from 'prop-types';

import DateTimeRangePicker from '../date-time-range-picker';
import DateRangePicker from '../date-range-picker';
import TimeRangePicker from '../time-range-picker';
import TimeDurationPicker from '../time-duration-picker';
import DatePicker from '../date-picker';
import DateTimePicker from '../date-time-picker';

const DateTimePickerRenderer = ({
    type,
    ...props
}) => {

    let Component;
    switch (type) {
        case 'time-range':
            Component = TimeRangePicker;
            break;
        case 'time-duration':
            Component = TimeDurationPicker;
            break;
        case 'date':
            Component = DatePicker;
            break;
        case 'datetime':
            Component = DateTimePicker;
            break;
        case 'date-range':
            Component = DateRangePicker;
            break;
        case 'datetime-range':
        default:
            Component = DateTimeRangePicker;
            break;
    }

    return (
        <Component
            {...props}
        />
    );
}

DateTimePickerRenderer.propTypes = {
    /** Picker to render. */
    type: PropTypes.oneOf(['time-range', 'time-duration', 'date', 'datetime', 'date-range', 'datetime-range'])
}

export default DateTimePickerRenderer;